import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BS } from '../../environment';

@Injectable({
  providedIn: 'root',
})
export class HomeService {

  constructor(private http: HttpClient) { }

  getFAQs = () => this.http.get<any>(`${BS}faq?PageSize=33&PageNumber=1`);

  getCenters = (req) => this.http.get<any>(`${BS}Center${req}`);

  getBanners = (pageSize, pageNumber) => this.http.get<any>(`${BS}Banner?PageSize=${pageSize}&PageNumber=${pageNumber}&IsMobile=false`);

  getCities = () => this.http.get<any>(`${BS}Shared/AutoCities`);

  getSessions = (req: FormData) => this.http.post<any>(`${BS}Booking/SearchSessions`, req);

  getAboutus = () => this.http.get<any>(`${BS}Aboutus/Get`);

  contactus = req => this.http.post<any>(`${BS}contactus`, req);

  GetConfiguration = () => this.http.get<any>(`${BS}Configuration/Get`);
 
}
